import React from 'react';
import { Calendar, Clock, Plus } from 'lucide-react';
import { format } from 'date-fns';
import { formatDateToUSA } from '../../../config/utils';

export default function ServiceSidebar({
  instances,
  currentBucketLabel,
  onAddService,
}) {
  const scheduledCount = instances.filter(i => i.status === 'scheduled').length;
  const pendingCount = instances.filter(i => i.status === 'pending').length;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <h3 className="font-semibold text-gray-800 mb-1">{currentBucketLabel}</h3>
      <p className="text-xs text-gray-500 mb-4">
        {scheduledCount} of {instances.length} scheduled
      </p>

      <div className="space-y-3">
        {instances.map((instance) => {
          const isScheduled = instance.status === 'scheduled';

          return (
            <div
              key={instance.instanceId}
              className={`flex items-start gap-3 p-3 rounded-lg border transition-all ${isScheduled
                ? "bg-green-50 border-green-200"
                : "bg-orange-50 border-orange-200"}`
              }
            >
              <div className="flex-shrink-0 mt-0.5">
                {isScheduled ? (
                  <Calendar className="w-4 h-4 text-green-600" />
                ) : (
                  <Clock className="w-4 h-4 text-orange-500" />
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium truncate ${isScheduled ? "text-green-800" : "text-gray-800"}`}>
                  {instance.serviceName}
                </p>
                {isScheduled ? (
                  <div className="flex items-center gap-2 mt-1">
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                      Scheduled
                    </span>
                    <span className="text-xs text-green-700 text-nowrap">
                      {formatDateToUSA(instance.appointmentDate)} - {instance.appointmentTime === 'full_day' ? 'Full Day' : instance.appointmentTime}
                    </span>
                  </div>
                ) : (
                  <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-orange-100 text-orange-800 mt-1">
                    Pending
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* {onAddService && (
        <button
          onClick={onAddService}
          className="mt-4 w-full flex items-center justify-center gap-2 px-4 py-2.5 border-2 border-dashed border-gray-300 rounded-lg text-sm font-medium text-gray-600 hover:border-green-400 hover:text-green-700 hover:bg-green-50 transition-all"
        >
          <Plus className="w-4 h-4" />
          Add Service
        </button>
      )} */}

      {pendingCount > 0 && (
        <p className="mt-4 text-xs text-gray-500 text-center">
          Select a date to schedule {pendingCount} remaining service{pendingCount !== 1 ? 's' : ''}
        </p>
      )}
    </div>
  );
};
